module.exports = __webpack_public_path__ + "static/favicon-5fdda2d2c82bdfd318afb11f02fa387f.ico";